<label [for]="controlId" class="field-label bd-field-label">Webhook URL</label>
<div class="input-wrapper">
  <input
    [id]="controlId"
    type="text"
    readonly
    [formControl]="urlCtrl"
    name="webhookUrl"
    class="bd-text-input tall"
  />
  <ul class="input-actions">
    <li>
      <button
        type="button"
        blazeIconButton
        blazeTooltip="Copy to Clipboard"
        (click)="copyUrlToClipboard()"
      >
        <mat-icon svgIcon="icon_copy_to_clipboard_16" />
      </button>
    </li>
    <li>
      <button
        type="button"
        blazeIconButton
        blazeTooltip="Generate new URL"
        (click)="generateNewWebhookId()"
      >
        <mat-icon svgIcon="icon_reload_16" />
      </button>
    </li>
  </ul>
</div>
